/** 제안 본문 제한. 프론트 입력과 서버 검증이 공유한다. */
export const SUGGESTION_LIMITS = { maxLength: 1000 };
//# sourceMappingURL=admin.js.map